import { Inject, Injectable } from '@angular/core';
import loadLibrary, { HeaderInfo, MainModule } from '@wasm/KopWeb_list';
import { ServerAPI } from '../serverapi';
import { saveLocalFiles } from '../utils/wasmVector';
import { TranslateService } from '../i18n/translate.service';
import { stringToUint8Array } from '../utils/utils';



@Injectable({
  providedIn: null
})
export class KopListService {

  constructor(@Inject('ServerApi') private electronAPI: ServerAPI, private translate: TranslateService) { }
  public wasmModule: MainModule | undefined;

  public async init(files: Record<string, any>) {
    if (this.wasmModule == undefined) {
      if (this.wasmModule == undefined) {
        let lib = await loadLibrary();
        this.wasmModule = lib;
      }
    }
    saveLocalFiles(files, this.wasmModule!);
  }



  // private testString(str:string) {
  //   let stripped = str.replace(/[0-9a-zA-Z=\/;\n -;\.\&\[\]_|]/g, '');
  //   console.log(stripped);
  //   const a = document.createElement('a');
  //   const blob = new Blob([stripped], {type: "text/plain"});
  //   const url = URL.createObjectURL(blob);
  //   a.href = url;
  //   a.download = "koplist.txt";
  //   a.click();
  //   URL.revokeObjectURL(url);
  // }


  public async generateList(klantNo: string) {
    let wasm = this.wasmModule;
    let ret: Record<string, any> = {};
    if (wasm != undefined) {
      let info = wasm.FS.analyzePath('/working/LST', undefined);
      if (!info.exists) {
        wasm.FS.mkdir('/working/LST', undefined);
      }


      let hInfo = await this.electronAPI.getUnlockKlantInfo(klantNo);

      if (hInfo != undefined) {
        let lb = new wasm.ListBridge();

        let currentLanguage = this.translate.currentLanguage();
        lb.listSXB(klantNo, hInfo, currentLanguage);
        let t = wasm.FS.readdir('/working/LST/');
        if (wasm.FS.analyzePath(`/working/LST/${klantNo}.LST`, undefined).exists) {
          let data = this.wasmModule!.FS.readFile(`/working/LST/${klantNo}.LST`);
          ret[`/working/LST/${klantNo}.LST`] = data;
        }
        if (wasm.FS.analyzePath(`/working/LST/${klantNo}.DBL`, undefined).exists) {
          let data = this.wasmModule!.FS.readFile(`/working/LST/${klantNo}.DBL`);
          ret[`/working/LST/${klantNo}.DBL`] = data;
        }
        if (wasm.FS.analyzePath(`/working/${klantNo}.XML`, undefined).exists) {
          let data = this.wasmModule!.FS.readFile(`/working/${klantNo}.XML`);
          ret[`/working/${klantNo}.XML`] = data;
        }

      }
    }
    return ret;
  }
}
